
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { fetchRunsheets } from './fetchRunsheets'
import { fetchScenarios } from './fetchScenarios'

type ShiftDriverPayload = {
  id: EntityId
  driverUserId: EntityId
}

export type ManageDriversPayload = {
  scheduleId: EntityId
  shifts: ShiftDriverPayload[]
  onSuccess?: () => void
}

export const manageDrivers = createAsyncThunk<void, ManageDriversPayload, ThunkApiContext>(
  'scenario/manageDrivers',
  async ({ scheduleId, shifts, onSuccess }, { getState, dispatch }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/manageDriver' : '/runsheet/manageDriver'

    await OLMSApiService.post<null>(endpoint, {
      shifts: shifts,
    })

    if (currentScreen === 'planning') {
      await dispatch(fetchScenarios({ scenarioIds: [scheduleId] }))
    }
    else {
      await dispatch(fetchRunsheets({ runsheetIds: [scheduleId] }))
    }

    if (onSuccess) {
      onSuccess()
    }
  },
)
